export default __webpack_public_path__ + "static/media/logo-mobile-footer.38480ff6.svg";